import { FC } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

type Props = Omit<MessageDescriptor, 'id'> & {
  id: string;
  lowercase?: boolean;
  uppercase?: boolean;
  [key: string]: any;
};

// This component replaces the FormattedMessage component from react-intl,
// allowing for extra props
const FormattedMessage: FC<Props> = ({
  id,
  lowercase,
  uppercase,
  values,
  ...props
}) => {
  const intl = useIntl();
  if (!id) return null;
  const msg = intl.formatMessage(
    {
      id: id,
      ...props,
    },
    values,
  );
  const msg_case = lowercase
    ? msg.toLowerCase()
    : uppercase
      ? msg.toUpperCase()
      : msg;
  const msg_split = msg_case.split('\n');
  const msg_br =
    msg_split.length > 1
      ? msg_split.map((line, idx, arr) =>
          idx < arr.length - 1 ? (
            <span key={idx}>
              {line}
              <br />
            </span>
          ) : (
            <span key={idx}>{line}</span>
          ),
        )
      : msg_split;

  return <>{msg_br}</>;
};

export default FormattedMessage;
